import { useQuery } from '@apollo/client';
import { Avatar } from '@mui/material';
import { GET_FILE_URL } from 'schemas/query';
import companyDummyImage from 'assets/images/users/company_logo_profile_detail.svg';
import { useEffect, useState } from 'react';
const CompanyProfileImage = ({ profilePicture, legalBusinessName, isModal, isFile, height, width }) => {
    const [url, setUrl] = useState('');

    const { data } = useQuery(GET_FILE_URL, {
        fetchPolicy: 'cache-first',
        variables: {
            key: profilePicture
        },
        skip: !profilePicture || isFile
    });

    useEffect(() => {
        if (data) {
            setUrl(data?.getSignedUrlFromKey?.signedUrl || '');
        }
    }, [data]);
    return (
        <Avatar
            sx={{ width: height || '86px', height: width || '86px', mr: !isModal ? '20px' : 0, background: 'transparent !important' }}
            alt={legalBusinessName}
            src={isFile ? profilePicture : url ? url : companyDummyImage}
        />
    );
};
export default CompanyProfileImage;
